// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul[data-v-9b50acb0]{padding-left:1.2em}li[data-v-9b50acb0]{margin-bottom:1em}.dp-logo-benefits[data-v-9b50acb0]{width:1.5em}.collapsed>.when-open[data-v-9b50acb0],.not-collapsed>.when-closed[data-v-9b50acb0]{display:none}", ""]);
// Exports
module.exports = exports;
